import config from '@bounty/creators-common/tamagui.config'

export default config
